import DarkTriangle from "./DarkTriangle";

export default DarkTriangle;
